import { PropsWithChildren, useState } from 'react'
import { InlineWidget, useCalendlyEventListener } from 'react-calendly'
import { TbCalendarEvent } from 'react-icons/tb'
import { pushGtmEvent } from 'helpers/gtm'
import { LINKS } from 'routes/constants'
import { useTrackingContext } from 'routes/components/Layout'
import { Link } from 'ui-kit/actions/link/Link'
import { fetchCalendlyData } from './helpers'
import clsx from 'clsx'
import classes from './Calendly.module.scss'

export function CalendlyWidget({
  calendlyUrl,
  isStyled,
}: {
  calendlyUrl: string
  isStyled?: boolean
}) {
  const { addTrackingToUrl } = useTrackingContext()

  const defaultWidgetHeight = '700px'
  const [widgetHeight, setWidgetHeight] = useState<string>(defaultWidgetHeight) // set default height

  const widgetStyles = {
    width: '100%',
    height: widgetHeight,
    minHeight: defaultWidgetHeight,
    overflow: 'hidden',
  }

  useCalendlyEventListener({
    onPageHeightResize: (event) => {
      setWidgetHeight(event.data?.payload.height) // Update height dynamically
    },

    onEventScheduled: (event) => {
      pushGtmEvent('calendly_event_scheduled')

      const payloadInviteeUri = event.data.payload?.invitee?.uri

      if (payloadInviteeUri) {
        trackCalendlyEventData(payloadInviteeUri)
      }
    },
  })

  async function trackCalendlyEventData(userData: string) {
    const user = await fetchCalendlyData(userData)
    pushGtmEvent('user_identify', {
      userName: user.name,
      userEmail: user.email,
    })
  }

  const defaultOptions = {
    hideEventTypeDetails: true,
    hideLandingPageDetails: true,
  }

  const styledOptions = {
    backgroundColor: '080a1e',
    textColor: 'ffffff',
    primaryColor: '806ef6',
    hideEventTypeDetails: true,
    hideLandingPageDetails: true,
  }

  return (
    <InlineWidget
      url={addTrackingToUrl(calendlyUrl)}
      pageSettings={isStyled ? styledOptions : defaultOptions}
      styles={widgetStyles}
    />
  )
}

export function BookCalendlyLink({
  children,
  className,
  type,
  isReversed,
  showIcon = true,
}: PropsWithChildren<{
  className: string
  type: string
  isReversed?: boolean
  showIcon?: boolean
}>) {
  return (
    <Link
      className={clsx(classes.button, className)}
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      type={type as any}
      href={LINKS.BOOK_A_DEMO}
    >
      <span
        className={clsx(
          classes.button_caption,
          isReversed && classes.button_caption__reversed,
        )}
      >
        {children}
      </span>
      {showIcon && (
        <TbCalendarEvent
          className={clsx(
            classes.button_icon,
            isReversed && classes.button_icon__reversed,
          )}
        />
      )}
    </Link>
  )
}
